import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import { FeedbackPage, DisagreementPage } from '../containers/Pages/Email'

const Routes = () => {
  return (
    <div>
      <Switch>
        <Route
          path="/email/feedback/:interactionId/:token/:defaultRate"
          component={FeedbackPage}
        />
        <Route
          path="/email/disagree/:interactionId/:token"
          component={DisagreementPage}
        />
        <Route render={() => <Redirect to="/" />} />
      </Switch>
    </div>
  )
}

export default Routes
